// Book preview extension (admin side): a book's "Look inside" PDF — uploaded
// here and opened in the store page's book player. The API's extension of the
// same id (aldoo-com-api catalog/store/extensions/book-preview) declares it; the
// Book content type lists it.
import { BookOpenIcon } from "@heroicons/react/24/outline"
import BookPreviewTab from "./BookPreviewTab"
import { CatalogEditorProvider, catalogSection, catalogVisible, useCatalogVisibilityContext } from "../shared/catalog-editor"

export const StoreProductExtension = {
  id: "book-preview",
  label: "Book Preview",
  description: "A book's look-inside PDF, opened in the book player on the store page",
  section: {
    component: catalogSection(BookPreviewTab),
    label: "Book Preview",
    icon: BookOpenIcon,
    order: 640,
    visible: catalogVisible("bookPreview"),
  },
  provider: CatalogEditorProvider,
  visibilityContext: useCatalogVisibilityContext,
}
